<sh-page flat theme="light">
  <div class="tabs-container">
    <sh-tabs role="tablist">
      <sh-tab-item
        label="{{ 'syngovia.label.customerOverview' | translate }}"
        [active]="activeTab === TAB_OVERVIEW"
        (click)="activateTab(TAB_OVERVIEW)"
        (keydown.enter)="activateTab(TAB_OVERVIEW)"
        (keydown.backspace)="activateTab(TAB_OVERVIEW)"
        onkeyup="activateTab(TAB_OVERVIEW)"
      ></sh-tab-item>
      <sh-tab-item
        label="{{ 'syngovia.label.healthcheck' | translate }}"
        [active]="activeTab === TAB_HEALTHCHECK"
        (click)="activateTab(TAB_HEALTHCHECK)"
        (keydown.enter)="activateTab(TAB_HEALTHCHECK)"
        (keydown.backspace)="activateTab(TAB_HEALTHCHECK)"
        onkeyup="activateTab(TAB_HEALTHCHECK)"
      ></sh-tab-item>
    </sh-tabs>

    <ng-container *ngIf="activeTab === TAB_OVERVIEW">
      <api-call-gate [apiCall]="networkConnections" #networkConCallGate>
        <ng-template #lastSuccessfulData let-networkConnections>
          <app-dna-syngovia-customer-overview
            [systemDetails]="systemDetails"
            [dataConnections]="networkConnections"
          >
          </app-dna-syngovia-customer-overview>
        </ng-template>
        <ng-container *ngIf="networkConCallGate.rawError$ | async as error">
          <ng-template #error *ngIf="error.status === 404">
            <app-dna-syngovia-empty-state></app-dna-syngovia-empty-state>
          </ng-template>
        </ng-container>
      </api-call-gate>
    </ng-container>

    <ng-container *ngIf="activeTab === TAB_HEALTHCHECK">
      <api-call-gate [apiCall]="serverHealth" #healthcheckCallGate>
        <ng-template #lastSuccessfulData let-serverHealth>
          <app-dna-syngovia-healthcheck
            [systemDetails]="systemDetails"
            [healthcheckData]="serverHealth"
            [selectedServer]="selectedServer"
          ></app-dna-syngovia-healthcheck>
        </ng-template>
        <ng-container *ngIf="healthcheckCallGate.rawError$ | async as error">
          <ng-template #error *ngIf="error.status === 404">
            <app-dna-syngovia-empty-state></app-dna-syngovia-empty-state>
          </ng-template>
        </ng-container>
      </api-call-gate>
    </ng-container>
  </div>
</sh-page>

<ng-container *ngIf="modalPortalVisible && !modalPortalConfirmed">
  <ng-container
    *ngTemplateOutlet="
      modalDisclaimer;
      context: {
        $implicit: {
          visible: modalPortalVisible && !modalPortalConfirmed,
          id: 'modalDisclaimerPortal',
          label: 'syngovia.message.disclaimer.portalTitle',
          message: 'syngovia.message.disclaimer.portalMessage',
          messageLastPart: 'syngovia.message.disclaimer.portal.lastPart',
          onClickFn: onClickConfirmModalPortal,
          confirm: 'syngovia.message.disclaimer.portalConfirm',
        },
      }
    "
  >
  </ng-container>
</ng-container>

<ng-container
  *ngIf="modalMobileVisible && (screenLayoutService.phone$ | async)"
>
  <ng-container
    *ngTemplateOutlet="
      modalDisclaimer;
      context: {
        $implicit: {
          visible: modalMobileVisible && (screenLayoutService.phone$ | async),
          id: 'modalDisclaimerMobile',
          label: 'syngovia.message.disclaimer.mobileTitle',
          message: 'syngovia.message.disclaimer.mobileMessage',
          onClickFn: onClickConfirmModalMobile,
          confirm: 'syngovia.message.disclaimer.mobileConfirm',
        },
      }
    "
  >
  </ng-container>
</ng-container>

<ng-template #modalDisclaimer let-data>
  <sh-modal
    sticky
    [visible]="data.visible"
    [id]="data.id"
    type="alert"
    label="{{ data.label | translate }}"
    modal-width="360px"
    modal-height="200px"
    role="alertdialog"
    aria-label="Disclaimer dialog"
  >
    <sh-text [innerHTML]="data.message | translate"></sh-text>
    <sh-button
      slot="footer"
      size="m"
      [label]="data.confirm | translate"
      (click)="data.onClickFn()"
      onkeyup="data.onClickFn()"
    ></sh-button>
  </sh-modal>
</ng-template>
